import classNames from 'classnames';
import PropTypes from 'prop-types';

import { Row } from '../display';
import SvgColorImg from '../SvgColorImg';

function Stars(props) {
  const {
    rating = 0,
    maxRating = 5,
    large,
    error,
  } = props;

  const stars = new Array(maxRating)
    .fill(null)
    .map((entry, index) => (index + 1));

  return (
    <Row gap={0} className="shrink-0">
      {stars.map((starId) => {
        // Compute full/empty/partially filled star ratio
        let maskRatio;
        if (rating !== undefined) {
          if (rating <= (starId - 1)) maskRatio = 0;
          else if (rating >= starId) maskRatio = 100;
          else maskRatio = 27 + (46 * (rating + 1 - starId));
        } else {
          maskRatio = 0;
        }

        return (
          <div
            className={classNames(
              'relative py-0.5',
              {
                'px-1': large,
                'px-0.5': !large,
              },
            )}
            key={`stars_${starId}`}
          >
            {/* // Background color */}
            <SvgColorImg
              src="/images/svg/gui/starFill.svg"
              imgColorAsCssFill
              absolute
              className={classNames(
                'top-0.5 fill-white',
                {
                  'w-8 h-8 left-1': large,
                  'w-6 h-6 left-0.5': !large,
                },
              )}
            />

            {/* // Yellow filling */}
            <div
              className={classNames(
                'absolute top-0.5 bg-transparent overflow-hidden',
                {
                  'w-8 h-8 left-1': large,
                  'w-6 h-6 left-0.5': !large,
                },
              )}
              style={{ width: `${maskRatio}%` }}
            >
              <div className={(large) ? 'h-8 w-8' : 'h-6 w-6'}>
                <SvgColorImg
                  description="cell"
                  src="/images/svg/gui/starFill.svg"
                  imgColorAsCssFill
                  className={classNames(
                    'top-0 left-0 fill-pxStarFill',
                    {
                      'h-8 w-8': large,
                      'h-6 w-6': !large,
                    },
                  )}
                  absolute
                />
              </div>
            </div>

            {/* // Outline */}
            <SvgColorImg
              description="cell"
              src="/images/svg/gui/starOutline.svg"
              imgColorAsCssFill
              className={classNames(
                {
                  'h-8 w-8': large,
                  'h-6 w-6': !large,
                  'opacity-70': (rating === undefined),
                  'fill-pxUiAlert': error,
                  'fill-pxStarOutline': !error,
                },
              )}
            />
          </div>
        );
      })}
    </Row>
  );
}

Stars.propTypes = {
  rating: PropTypes.number,
  maxRating: PropTypes.number,
  large: PropTypes.bool,
  error: PropTypes.bool,
};

export default Stars;
